import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './PDFWindow.css'
import '../../../styles/variables.css'
import { useOrientation } from '../../../contexts/OrientationContext'

import closeIcon from '../../../assets/icons/close-icon.svg'
import maximizeIcon from '../../../assets/icons/fullscreen-icon.svg'
import minimizeIcon from '../../../assets/icons/minscreen-icon.svg'

function PDFWindow({ type, onClose, children }) {
  const { isPortrait } = useOrientation()
  const [isMaximized, setIsMaximized] = useState(false)

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized)
  }

  return (
    <div className={`window-overlay ${isPortrait ? 'portrait' : ''}`}>
      <div className={`window ${type} ${isMaximized ? 'maximized' : ''}`}>
        <div className="window-header">
          <div className="window-header-left">
            <img
              className="close-icon"
              onClick={onClose}
              src={closeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
            <img
              className="close-icon"
              onClick={toggleMaximize}
              src={isMaximized ? minimizeIcon : maximizeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
          </div>
          <span className="window-title">
            {type === 'pdf'
              ? 'PDF Viewer'
              : type === 'blank'
                ? 'Blank Window'
                : 'Window'}
          </span>
        </div>
        <div className="window-content">{children}</div>
      </div>
    </div>
  )
}

PDFWindow.propTypes = {
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default PDFWindow
